import React from "react";
import "./index.scss";
import { Button, Grid, TextField } from "@mui/material";
import Select from "react-select";
import StickyHeaderCon from "../../../common-utilities/core/sticky-header-table";

const TransferTransaction = () => {
  const transactionColumns = [
    { id: "amount", label: "Amount" },
    { id: "type", label: "Type" },
    { id: "reason", label: "Reason" },
    { id: "checkNumber", label: "Check Number" },
    { id: "checkDate", label: "Check Date" },
    { id: "transactionPaidDate", label: "Transaction Paid Date" },
    { id: "comments", label: "Comments" },
    { id: "payableTo", label: "Payable To" },
    { id: "returnCheckTo", label: "Return Check To" },
    { id: "checkFrom", label: "Check From" },
  ];
  return (
    <div className="trasfer-con">
      <Grid container md={12} sx={{ mt: 3, mb: 3 }}>
        <Grid item md={3} xs={6}>
          <TextField
            id="store"
            label="Store"
            fullWidth
            variant="outlined"
            className="sel-item"
          />
        </Grid>
        <Grid item md={3} xs={6}>
          <Select
            placeholder="Satellite"
            className="sel-item"
            classNamePrefix="custom_select"
          />
        </Grid>
        <Grid item md={3} xs={6}>
          <Select
            placeholder="Sequence"
            className="sel-item"
            classNamePrefix="custom_select"
          />
        </Grid>
        <Grid
          item
          md={3}
          xs={6}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button variant="outlined" sx={{ mr: 3 }} size="small">
            Reset
          </Button>
          <Button variant="contained" size="small">
            Save{" "}
          </Button>
        </Grid>
      </Grid>
      <Grid container md={12} sx={{ display: "flex", flexDirection: "column" }}>
        <div className="title header">Closing Fees Collected</div>
        <StickyHeaderCon
          containerHeight="transferTranTable"
          columnsList={transactionColumns}
        />
      </Grid>
      <Grid
        container
        md={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Grid item md={3}>
          <TextField label="Balance Date" fullWidth variant="outlined" />
        </Grid>
        <Grid item md={6} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button variant="contained" sx={{ mr: 5 }} size="small">
            New
          </Button>
          <Button variant="outlined" size="small">
            Delete
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default TransferTransaction;
